import Backbone from 'backbone';
import CatalogItemReference from './CatalogItemReference';
import app from '../app';

export default Backbone.Collection.extend({
    initialize: function (models, options) {
        this.model = CatalogItemReference;
    },

    url: function () {
        return `${app.config.contextPath}/catalog_items`;
    }
});


// WEBPACK FOOTER //
// ./model/CatalogItemReferences.js